export default __webpack_public_path__ + "static/media/img_muslinTwoBibsTwo_yg_p.d832a5b4.jpg";